import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { generateSessionId } from '@/helpers/session';
import { generateFingerprint } from '@/helpers/fingerprint';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/queryClient';
import store from '@/store/configureStore';
import { AppRoutes } from '@/routes';
import * as serviceWorker from './serviceWorker';
import './i18n';

export let fingerprint;
export let sessionId = generateSessionId();

(async () => {
  try {
    const res = await generateFingerprint();
    fingerprint = res?.hash;
    sessionId = generateSessionId();
  } finally {
    createRoot(document?.getElementById('root')).render(
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <RouterProvider router={AppRoutes} />
        </Provider>
        {import.meta.env.VITE_RELEASE === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    );
  }
})();

serviceWorker.unregister();
